import {
  getStorage,
  ref,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from 'firebase/storage';
import { getType } from 'mime';
import { gzip } from 'pako';
import firebaseApp from './app';

const getFirebaseStorage = async () => getStorage(await firebaseApp);

const storage = getFirebaseStorage();

const bucketName = async () => (await firebaseApp).options.storageBucket;

export const getNewsImagePath = async (roleName: string): Promise<string> =>
  `https://storage.googleapis.com/${await bucketName()}/newsImages/${roleName}`;

export const fireSafetyCategoryImage = async (name: string): Promise<string> =>
  `https://storage.googleapis.com/${await bucketName()}/fireSafetyCategoryImages/${name}.jpg`;

export const getThumbnailImage = async (name: string): Promise<string> =>
  `https://storage.googleapis.com/${await bucketName()}/videoThumbnailImages/${name}`;

export const deleteCategoryImage = async (name: string): Promise<void> =>
  deleteObject(ref(await storage, `fireSafetyCategoryImages/${name}.jpg`));

export const deleteVideoImage = async (name: string): Promise<void> =>
  deleteObject(ref(await storage, `videoThumbnailImages/${name}`));

export const storeNewsImage = async (
  timeStamp: number,
  file: File,
): Promise<void> => {
  const storageRef = ref(await storage, `newsImages/${timeStamp}.jpg`);
  await uploadBytes(storageRef, file);
};

export const addCategoryImage = async (
  titleUuid: string,
  file: File,
): Promise<void> => {
  const storageRef = ref(
    await storage,
    `fireSafetyCategoryImages/${titleUuid}.jpg`,
  );
  await uploadBytes(storageRef, file);
};

export const addVideoThumbnail = async (
  fileName: string,
  file: File,
): Promise<void> => {
  const storageRef = ref(await storage, `videoThumbnailImages/${fileName}`);
  await uploadBytes(storageRef, file);
};

export const addVideoFile = async (
  directory: string,
  filename: string,
  file: Uint8Array,
): Promise<string> => {
  const storageRef = ref(
    ref(ref(await storage, 'videos'), directory),
    filename,
  );

  const splitFilename = filename.split('.');
  const mimeType =
    getType(splitFilename[splitFilename.length - 1]) ?? undefined;

  // compress e.g. playlists, but not binary videos
  const compress = !mimeType?.startsWith('video');
  const dataToSend = compress ? gzip(file) : file;

  const result = await uploadBytes(storageRef, dataToSend, {
    contentType: mimeType,
    contentEncoding: compress ? 'gzip' : undefined,
  });
  return getDownloadURL(result.ref);
};

export default storage;
